import type { Editor } from '@tiptap/core';
import { applyContentPreservingSelection } from './apply-content-preserving-selection';
import type { EditorContentSyncContext } from './editor-host-config';
import { getEditorHostConfig } from './editor-host-config';

/** Applies synced HTML through the host's apply, read per call; unset, it applies silently. */
export function applySyncedHtmlContent(
  editor: Editor,
  content: string,
  context: EditorContentSyncContext
): void {
  const hostApply = getEditorHostConfig().applyHtmlContentPreservingSelection;
  if (hostApply) {
    hostApply(editor, content, context);
    return;
  }
  applyContentPreservingSelection(
    editor,
    () => {
      editor.commands.setContent(content, {
        emitUpdate: false,
        parseOptions: { preserveWhitespace: 'full' },
        errorOnInvalidContent: false,
      });
    },
    () => undefined
  );
}
